import ClubProfileAside from './ClubProfileAside';

export default ClubProfileAside;
